if (!customElements.get('pdp-coupon-banner')) {
  customElements.define('pdp-coupon-banner', class PdpCouponBanner extends HTMLElement {
    constructor() {
      super();

      this.update = this.update.bind(this);
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.unsubscribe = (window.FoxTheme && FoxTheme.pubsub)
        ? FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.update)
        : null;
      document.addEventListener('cart:refresh', this.update);
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      document.removeEventListener('cart:refresh', this.update);
    }

    async update() {
      if (!this.sectionId || this.refreshing) return;
      this.refreshing = true;

      try {
        const url = `${window.location.pathname}?section_id=${encodeURIComponent(this.sectionId)}`;
        const response = await fetch(url);
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('pdp-coupon-banner');
        if (!fresh) return;

        const freshText = fresh.querySelector('[data-pcb-text]');
        const textEl = this.querySelector('[data-pcb-text]');
        if (freshText && textEl) textEl.textContent = freshText.textContent;

        // Mirror the server's visibility decision (no coupon => hidden, no space).
        this.hidden = fresh.hasAttribute('hidden');
      } catch (err) {
        // Leave the current state untouched on failure.
      } finally {
        this.refreshing = false;
      }
    }
  });
}
